exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._378AqQXt7Vn66ek8Mf4Fo5:before{color:\"[theme:redDark, default:#a80000]\"!important}._32S8K94lku5ujN8zmSd9ED:before{color:\"[theme:green20, default:#0b6a0b]\"!important}html[dir] ._32S8K94lku5ujN8zmSd9ED:before{margin-bottom:2px}._3Y1jo0XOp_HAd3rW6--a2L:before{color:\"[theme:themePrimary, default:#0078D4]\"!important}", ""]);
// Exports
exports.locals = {
	"redDark": "_378AqQXt7Vn66ek8Mf4Fo5",
	"snooze": "_32S8K94lku5ujN8zmSd9ED",
	"accounts": "_3Y1jo0XOp_HAd3rW6--a2L"
};